"use client";

import { useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
gsap.registerPlugin(useGSAP, ScrollTrigger);
export default function Booking() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add({
      reduced: "(prefers-reduced-motion: reduce)",
      normal: "(prefers-reduced-motion: no-preference)"
    }, context => {
      const conditions = context.conditions as {
        reduced: boolean;
        normal: boolean;
      };
      if (conditions.reduced) {
        gsap.set([".eyebrow-reveal", ".headline-reveal", ".body-reveal", ".photo-reveal"], {
          opacity: 1,
          y: 0
        });
        return;
      }
      const tl = gsap.timeline({
        defaults: {
          ease: "cubic-bezier(.2,.7,.2,1)",
          duration: 0.62
        },
        scrollTrigger: {
          trigger: container.current,
          start: "top 82%"
        }
      });
      tl.from(".eyebrow-reveal", {
        opacity: 0,
        y: 16
      }).from(".headline-reveal", {
        opacity: 0,
        y: 16
      }, "+=0.03").from(".body-reveal", {
        opacity: 0,
        y: 16
      }, "+=0.03").from(".photo-reveal", {
        opacity: 0,
        y: 24,
        duration: 0.8
      }, "-=0.44");
    });
  }, {
    scope: container
  });
  return <section data-section-id="24585" id="heroservicebooking" data-nav="light" ref={container} className="relative overflow-hidden bg-background text-foreground py-32 md:py-44">
      <div className="mx-auto w-full max-w-[1360px] px-5 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-8">
          {}
          <div className="lg:col-span-7 lg:pt-24 xl:pt-28">
            {}
            <div className="eyebrow-reveal flex items-center gap-2">
              <span aria-hidden="true" className="block h-[14px] w-[3px]" style={{
              backgroundColor: "var(--primary)"
            }} />
              <span className="font-sans text-[13px] font-semibold uppercase tracking-[0.18em]" style={{
              color: "var(--primary)"
            }}>
                Trusted Pros
              </span>
              <span aria-hidden="true" className="block h-[14px] w-[3px]" style={{
              backgroundColor: "var(--primary)"
            }} />
            </div>

            {}
            <h2 className="headline-reveal mt-4 font-mono uppercase text-foreground" style={{
            fontSize: "clamp(3.75rem, 9vw, 8.75rem)",
            fontWeight: 700,
            letterSpacing: "-0.01em",
            lineHeight: 0.92
          }}>
              Expert home
              <br />
              services,
              <br />
              booked fast.
            </h2>

            <p className="body-reveal mt-12 max-w-[54ch] font-sans" style={{
            color: "var(--muted-foreground)",
            fontSize: "clamp(1.125rem, 1.35vw, 1.3125rem)",
            fontWeight: 400,
            letterSpacing: "-0.005em",
            lineHeight: 1.55
          }}>
              Handy Heroes connects you with vetted local contractors for every
              repair need. From plumbing and electrical to appliance fixes,
              our platform makes finding reliable help straightforward.
              Submit your request today to get matched with independent
              local professionals serving metro Atlanta.
            </p>
          </div>

          {}
          <div className="relative lg:col-span-5 lg:self-center">
            {}
            <div aria-hidden="true" className="pointer-events-none absolute -right-16 -top-16 z-0 w-[520px] max-w-none lg:-right-24 lg:-top-24 lg:w-[620px]" style={{
            opacity: 0.06
          }}>
              <svg viewBox="0 0 620 300" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-auto w-full">
                <path d="M0 260 L80 180 L140 220 L210 120 L280 200 L340 150 L410 230 L470 170 L540 210 L620 140" stroke="var(--foreground)" strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
                <path d="M0 280 L60 230 L130 250 L200 180 L270 240 L330 210 L400 260 L460 220 L530 250 L620 200" stroke="var(--foreground)" strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
                <path d="M0 220 L70 150 L150 190 L220 90 L290 170 L360 120 L430 200 L500 140 L570 180 L620 110" stroke="var(--foreground)" strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
              </svg>
            </div>

            <div className="photo-reveal relative z-10">
              <div className="relative aspect-[4/5] w-full overflow-hidden rounded-lg">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/contractor_booking_service.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/contractor_booking_service.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/contractor_booking_service.png-wvc-sizes" alt="Independent service professional using a tablet while scheduling an in-home service call" loading="lazy" decoding="async" className="h-full w-full object-cover" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}